var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.72301 128.72299",
    id: "svg12",
    width: 128.72301,
    height: 128.72299,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 64.361504,128.723 C 99.907394,128.723 128.723,99.907392 128.723,64.361496 128.723,28.815605 99.907394,-4.0283203e-6 64.361504,-4.0283203e-6 28.815614,-4.0283203e-6 3.6010742e-6,28.815605 3.6010742e-6,64.361496 3.6010742e-6,99.907392 28.815614,128.723 64.361504,128.723 Z",
    fill: "#1C77C3",
    id: "path2-3",
    style: {
      fill: "#1C77C3",
      fillOpacity: 1,
      strokeWidth: 1.60904
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g884",
    transform: "matrix(0.71843466,0,0,0.71843466,28.439771,29.876602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "imagebot_31",
    strokeLinejoin: "round",
    d: "M 9.731,90.651604 V 39.096603 L 50,64.874604 90.269,39.096603 V 90.651604 L 50,64.874604 Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 5,
    fill: "#d1d1d1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g878",
    transform: "translate(0,-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "imagebot_32",
    strokeLinejoin: "round",
    strokeOpacity: "null",
    height: 45.249001,
    width: 14.585,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeDasharray: "none",
    y: 19.845604,
    x: 42.632,
    strokeWidth: 5,
    fill: "#d1d1d1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "imagebot_34",
    strokeLinejoin: "round",
    strokeOpacity: "null",
    height: 12.483,
    width: 59.244999,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeDasharray: "none",
    y: 7.3486032,
    x: 20.485001,
    strokeWidth: 5,
    fill: "#d1d1d1",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "imagebot_35",
    strokeLinejoin: "round",
    strokeOpacity: "null",
    fillOpacity: "null",
    height: 0.52429003,
    width: 0,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeDasharray: "none",
    y: 44.1185,
    x: 110.5275,
    strokeWidth: 3,
    fill: "#cccccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.2f94460bf9721427a83919b5667f5e34.svg";
export { ForwardRef as ReactComponent };